// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c9d55f2a","239":"f63dc284","453":"0c7f5683","455":"a4ac0e3a"}[chunkId] + ".chunk.js";
};